export const PRODUCT_CATEGORY_COUNT_FACETS = ["main_category", "category"];

export const getMainCategoryFacetEntries = (response) => {
  const mainCategoryFacets = response?.facets?.main_category || {};
  const destinationCategoryFacets = response?.facets?.category || {};

  // main_category selects the L1 cards. Each card links to a PLP filtered by
  // category, so display that facet's count to match the destination result set.
  return Object.entries(mainCategoryFacets)
    .filter(([name, count]) => name && Number(count) > 0)
    .map(([name, count]) => {
      const destinationCount = Number(destinationCategoryFacets[name]);

      return {
        name,
        count: destinationCount > 0 ? destinationCount : Number(count),
      };
    })
    .sort((a, b) => {
      if (b.count !== a.count) {
        return b.count - a.count;
      }

      return String(a.name).localeCompare(String(b.name));
    });
};
